// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { DOCUMENT_MODE } = DOCUMENTS;

export default function AddAnotherSignature(props) {
  return (
    <div
      className="add-another-signature-footer"
      data-test="add-another-signature-footer">
      <span
        className="add-another-signer-wrapper"
        data-test="add-another-signer-wrapper"
        onClick={() => props.onAddSignBlock()}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        <span
          className="plusicon"
          data-test="addanothersignature-addsignblock-btn">
          <FontAwesomeIcon icon={["far", "plus"]} className="" />
        </span>
        <div
          className="add-another-signer-btn"
          data-test="add-another-signer-btn">
          <div
            className="add-another-signer-title"
            data-test="add-another-signer-title">
            {props.mode === DOCUMENT_MODE.TEMPLATE
              ? "Add another signer tag placeholder"
              : "Add another signer tag"}
          </div>
          <div
            data-test="addanothersignature-info-div"
            className="add-another-signer-desc">
            You can add as many signer tags as you want
          </div>
        </div>
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/SignatureListPane/AddAnotherSignature.js